// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"11aeb6bd","455":"18457e6d"}[chunkId] + ".chunk.js";
};